"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var selectLinkType_1 = require("./selectLinkType");
var CLASS_NAME = 'ontodia-edit-form';
var EditLinkForm = /** @class */ (function (_super) {
    tslib_1.__extends(EditLinkForm, _super);
    function EditLinkForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { linkModel: props.link.data };
        return _this;
    }
    EditLinkForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, view = _a.view, metadataApi = _a.metadataApi, link = _a.link;
        var linkModel = this.state.linkModel;
        var source = view.model.getElement(link.sourceId).data;
        var target = view.model.getElement(link.targetId).data;
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: CLASS_NAME + "__body" },
                React.createElement("div", { className: CLASS_NAME + "__form-row" },
                    React.createElement(selectLinkType_1.SelectLinkType, { view: view, metadataApi: metadataApi, link: linkModel, source: source, target: target, onChange: function (data) { return _this.setState({ linkModel: data }); } }))),
            React.createElement("div", { className: CLASS_NAME + "__controls" },
                React.createElement("button", { className: "ontodia-btn ontodia-btn-success " + CLASS_NAME + "__apply-button", onClick: function () { return _this.props.onApply(_this.state.linkModel); } }, "Apply"),
                React.createElement("button", { className: 'ontodia-btn ontodia-btn-danger', onClick: this.props.onCancel }, "Cancel"))));
    };
    return EditLinkForm;
}(React.Component));
exports.EditLinkForm = EditLinkForm;
